<template>
  <div>
    <div class="container">
      <div class="profile-page-title row justify-content-center">
        <div class="col-lg-auto col-12">
          <span>{{ $t('my_achievements') }}</span>
        </div>
        <div class="col-lg-auto col-12">
          <router-link :to="{ name: 'profile.exams' }">{{ $t('tests_results') }}</router-link>
        </div>
        <div class="col-lg-auto col-12">
          <router-link :to="{ name: 'profile.map' }">{{ $t('map') }}</router-link>
        </div>
      </div>
    </div>
    <div class="container-fluid blueback-solid  medal-text-notice">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center px-lg-0 px-5">
            <p>{{ $t('medals_desc1') }}<br>
              {{ $t('medals_desc2') }}</p>
            <p><span class="strong-green">{{ $t('medals_desc3') }}</span></p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <modal
          max-width="352px"
          mini
          :show="selectedMedal != null"
          @close="selectedMedal = null"
      >
        <MedalPopup v-if="selectedMedal"
                    :medal="selectedMedal"
                    @close="close"/>
        <template v-slot:footer/>
      </modal>
      <div class="row" v-if="loading">
        <div class="col-12 py-5">
        </div>
      </div>
      <div class="row" v-else>
        <div class="col-12">
          <div
              class="medal-category-list-item"
              v-for="(medals, category) in medalsCategories"
              :key="category">
            <h3 class="text-center medal-category-header">{{ category }}</h3>
            <div class="row justify-content-center mb-3">
              <div class="col-lg-2 col-6 mb-3 medal-item" v-for="medal in medals" :key="medal.id"
                   :class="{'medal-none' : !medal.userMedal}"
                   @click="medalClick(medal, $event)">
                <div class="medal-image text-center">
                  <img v-if="medal.userMedal" :src="medal.image" :title="medal.name" :alt="medal.name"/>
                  <img v-else :src="medal.image_none" :title="medal.name" :alt="medal.name"/>
                </div>
                <div class="medal-name text-center mt-2">{{ medal.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import medalApi from '@/data/MedalApi';
import MedalPopup from "./MedalPopup";

export default {
  name: 'Browse',
  components: {
    MedalPopup,
  },
  data() {
    return {
      medals: [],
      loading: true,
      medalsCategories: {},
      selectedMedal: null,
      popupStyle: {top: 0, left: 0},
    }
  },

  mounted() {
    this.fetchMedals()
  },

  methods: {
    fetchMedals() {
      medalApi.fetchMedals()
          .then(response => {
            this.medals = response;
            let mc = {}
            this.medals.forEach((medal) => {
              if (!(medal.category.name in mc))
                mc[medal.category.name] = []
              //TODO: удалить, только для отладки
              if (process.env.NODE_ENV === 'development') {
                medal.image = 'http://poliglotiki.com' + medal.image
                medal.image_none = 'http://poliglotiki.com' + medal.image_none
              }
              mc[medal.category.name].push(medal)
            });
            this.medalsCategories = mc
            console.log("medalsCategories", this.medalsCategories)
            this.loading = false
          });
    },
    medalClick(medal, event) {
      console.log("medal, event", medal, event)
      //this.$emit('click', medal)
      this.popupStyle = {top: (event.clientY - 400) + 'px', left: (event.clientX - 400) + 'px'}
      this.selectedMedal = medal
    },

    close() {
      if (this.selectedMedal != null) {
        this.selectedMedal = null
      }
    }
  },

}
</script>

<style>
.profile-page-title a, .profile-page-title a:hover {
  color: #0493c3;
  border-bottom: 1px solid;
}

.medal-name {
  color: #231c37;
  font-size: 16px;
  line-height: 18px;
  font-family: "Manrope Bold";
}

.medal-image img {
  width: 100px;
  max-width: 100%;
}

.medal-none {
  opacity: 0.5;
}

.medal-category-header {
  color: #231c37;
  font-family: "Manrope Bold";
  font-size: 24px;
  margin-top: 40px;
  margin-bottom: 60px;
}

.medal-category-list-item {
  border-bottom: 1px solid #d7e1e5;
}

.medal-item {
  padding-bottom: 30px;
  cursor: pointer;
}

.medal-text-notice, .medal-text-notice p {
  font-size: 18px;
  line-height: 24px;
  color: #4f4d5c;
}

.medal-text-notice .strong-green {
  font-size: 21px;
}

.medal-text-notice.blueback-solid {
  padding-top: 35px;
  padding-bottom: 20px;
}

@media (max-width: 767px) {
  .medals-popup-absolute {
    left: 0 !important;
    top: -450px !important;
  }

}

@media (min-width: 767px) {
  .modal-dialog {
    width: 352px !important;
    max-width: 100%;
  }
}

</style>
